import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=4dfa11bb&"
import script from "./TaskList.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports